export const ListDocumentsResourcesBS: ListDocumentsResourcesInterface = {
  title: "Lista dokumenata",
  selectBranch: "Odaberite poslovnicu",
  selectBranchPlaceholder: "Odaberite poslovnicu...",
  fileName: "Naziv datoteke",
  fileSize: "Veličina",
  uploadDate: "Datum uploada",
  noFiles: "Nema dokumenata za ovu poslovnicu.",
  loading: "Učitavanje...",
  noBranches: "Nemate dodijeljenih poslovnica.",
};

export const ListDocumentsResourcesEN: ListDocumentsResourcesInterface = {
  title: "List Documents",
  selectBranch: "Select branch",
  selectBranchPlaceholder: "Select a branch...",
  fileName: "File name",
  fileSize: "Size",
  uploadDate: "Upload date",
  noFiles: "No documents for this branch.",
  loading: "Loading...",
  noBranches: "You are not assigned to any branch.",
};

export const ListDocumentsResourcesDE: ListDocumentsResourcesInterface = {
  title: "Dokumentenliste",
  selectBranch: "Filiale auswählen",
  selectBranchPlaceholder: "Filiale auswählen...",
  fileName: "Dateiname",
  fileSize: "Größe",
  uploadDate: "Hochladedatum",
  noFiles: "Keine Dokumente für diese Filiale.",
  loading: "Wird geladen...",
  noBranches: "Sie sind keiner Filiale zugeordnet.",
};

export interface ListDocumentsResourcesInterface {
  title: string;
  selectBranch: string;
  selectBranchPlaceholder: string;
  fileName: string;
  fileSize: string;
  uploadDate: string;
  noFiles: string;
  loading: string;
  noBranches: string;
}
